module.exports = __webpack_public_path__ + "img/place_wftgy.caba43d5.png";